// extracted by mini-css-extract-plugin
export default {"header":"page-header_header__YJ4KQ","page_title":"page-header_page_title__h3pEm","page_title_link":"page-header_page_title_link__GzEii","right_slot":"page-header_right_slot__uGcVv"};